<template>
  <div class="container">
    <top-menu :current="['news']"></top-menu>

    <div class="main-container">
      <div class="summary-series__news">
        <div
          class="summary-series__news-card"
          v-for="item in news"
          :key="item.id"
        >
          <router-link :to="{ name: 'Article', params: { id: item.id } }" class="summary-series__news-card-a">
            <div class="summary-series__news-image">
              <img :src="item.img_url" />
            </div>
            <div class="summary-series__news-caption">
              {{ item.title }}
            </div>
            <div class="summary-series__news-information">
              <div class="summary-series__news-information__assist">
                <span class="athm-card-unit-information__item">{{
                  item.published_at
                }}</span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="new-more" @click="more" v-if="!is_end">加载更多</div>
      <div class="new-more" v-if="is_end">数据已全部加载</div>
    </div>
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import { getAllNews } from "@/api/news.js";
export default {
  name: "News",
  components: {
    TopMenu,
  },
  data() {
    return {
      page: 1,
      limit: 20,
      news: [],
      is_end: false,
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.news = [];
    this.getData();
  },
  beforeDestroy() {},
  methods: {
    getData() {
      getAllNews({ page: this.page, limit: this.limit }).then((response) => {
        if (response.data.length < this.limit) {
          this.is_end = true;
        }

        var that = this

        response.data.forEach(resp => {
            that.news.push(resp);
        });

        console.log(that.news);
      });
    },
    more() {
      this.page = this.page + 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
   position: relative;
  top:100px;
}
.main-container {
  margin: 0.8rem 0;
  .new-more {
    text-align: center;
    margin: 10px 0 15px;
  }
}

.summary-series__news {
  width: 100%;
  background-color: #ffffff;
  .summary-series__news-card {
    line-height: 1;
    overflow: hidden;
    .summary-series__news-card-a {
      position: relative;
      display: block;
      padding: 12px 26px 12px 20px;
      overflow: hidden;
    }
    .summary-series__news-image {
      position: relative;
      float: right;
      width: 33.333%;
      margin: 0 -6px 0 12px;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        -o-object-fit: cover;
        object-fit: cover;
        pointer-events: none;
      }
    }
    .summary-series__news-caption {
      max-height: 48px;
      font-size: 16px;
      color: #111e36;
      line-height: 24px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .summary-series__news-information {
      position: absolute;
      bottom: 18px;
      left: 20px;
      width: calc(66.666% - 36.666px);
      .summary-series__news-information__assist {
        position: relative;
        font-size: 1px;
        color: #666d7f;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>

